import styled from 'styled-components'
import { useEffect } from 'react'
import Link from 'components/Next/Link'
import { useRouter } from 'next/router'
import { route } from 'next/dist/next-server/server/router'

  const navs = [
    {
      name: 'Portfolio',
      icon: 'hand-holding-usd',
      href: '/'
    },
    {
      name: 'Performance',
      icon: 'chart-bar',
      href: '/performance'
    },
    {
      name: 'Analytics',
      icon: 'chart-pie',
      href: '/analytics'
    },
    {
      name: 'WNY28',
      icon: 'chart-line',
      href: '/western-new-york-28-index'
    },
    {
      name: 'About',
      icon: 'info-circle',
      href: '/about'
    },
  ]

const Sidebar = ({  }) => {
  const router = useRouter()

  const sidebarExpanded = true

  // useEffect(() => {
  //   document.documentElement.style.setProperty('--Sidebar_Width', sidebarExpanded ? 'var(--Sidebar_Width_Expanded)' : 'var(--Sidebar_Width_Collapsed)')
  // }, [sidebarExpanded])

  return (
    <S_Sidebar>
        <S_SidebarContent>
          <S_NavOptions>
            {
              navs.map(({ name, icon, href }, index) => 
                <Link href={href} shallow={true}>
                  <S_NavOption 
                    active={
                      href === '/'
                        ? router.pathname === '/' || router.pathname.includes('holdings')
                        : router.asPath.includes(href)
                    } 
                    key={`navOption${index}`} 
                    expanded={sidebarExpanded}
                  >
                    
                    <S_NavContent expanded={sidebarExpanded}>
                      <S_Icon className={`fa fa-${icon}`} />
                      <S_Text shrink={!sidebarExpanded}>{ name }</S_Text>
                    </S_NavContent>
                    
                  </S_NavOption>
                </Link>
              ) 
            }
          </S_NavOptions>
      </S_SidebarContent>
    </S_Sidebar>
  )
}

export default Sidebar

const S_Sidebar = styled.div`
  top: 0;
  position: fixed;
  width: var(--Sidebar_Width);
  height: 100vh;
`

const S_SidebarContent = styled.div`
  height: 100%;
  box-shadow: var(--Neuo);
  overflow: hidden;
  padding-top: 1rem;
`

const S_NavOptions = styled.div`
  width: 100%;
  padding-top: var(--Header_Height);
`

const S_NavOption = styled.div`
  cursor: pointer;
  background: ${props => props.active ? 'var(--Primary)' : 'none'};
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.expanded ? 'auto' : 'center'};
  align-items: center;
  height: ${props => props.expanded ? 'var(--Header_Height)' : 'var(--Sidebar_Width_Collapsed)'};
  color: var(--Font_Color);
  width: var(--Sidebar_Width);

  * {
    color: ${props => props.active ? 'var(--Font_Color_Invert)' : 'var(--Font_Color_Label)'};
  }

  &:hover {
    background: ${props => props.active ? 'var(--Primary)' : 'var(--Surface_1)'};
    * {
      color: ${props => props.active ? 'var(--Font_Color_Invert)' : 'var(--Font_Color_Label)'};
    }
  }
`

const S_NavContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${props => props.expanded ? '0' : '8px'};
  height: ${props => props.expanded ? '100%' : 'auto'};
  align-items: ${props => props.expanded ? 'center' : 'auto'};
`

const S_Icon = styled.i`
  font-size: var(--Font_Size_Icon_Small);
  width: 4.75rem;
  display: flex;
  justify-content: center;
`

const S_Text = styled.div`
  font-size: ${props => props.shrink ? '12px' : 'var(--Font_Size_Title)'};
  letter-spacing: var(--Letter_Spacing_Title);
  /* text-transform: uppercase;
  font-weight: 600; */
`
